export default __webpack_public_path__ + "static/media/info.8e8d6736.svg";